import React from 'react';
import './AmaLaunchModal.css';

interface AmaFeatureDemoProps {
  creatorSlug?: string;
  accentColor?: string;
  gradientStart?: string;
  gradientEnd?: string;
  className?: string;
}

const InstagramGlyph: React.FC<{ className?: string }> = ({ className = '' }) => (
  <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <rect x="3" y="3" width="18" height="18" rx="5" stroke="currentColor" strokeWidth="2" />
    <circle cx="12" cy="12" r="4" stroke="currentColor" strokeWidth="2" />
    <circle cx="17.5" cy="6.5" r="1" fill="currentColor" />
  </svg>
);

const AmaFeatureDemo: React.FC<AmaFeatureDemoProps> = ({
  creatorSlug,
  accentColor = '#8b5cf6',
  gradientStart = '#4c1d95',
  gradientEnd = '#db2777',
  className = '',
}) => {
  const demoStyle = {
    '--ama-accent': accentColor,
    '--ama-gradient-start': gradientStart,
    '--ama-gradient-end': gradientEnd,
  } as React.CSSProperties;

  return (
    <div className={className} style={demoStyle} aria-hidden="true">
      <div className="ama-launch-demo">
        <div className="ama-launch-scene ama-launch-scene-fan">
          <div className="ama-launch-scene-label"><span>1</span> A fan visits your .fans page</div>
          <div className="ama-launch-fans-card">
            <div className="ama-launch-fans-title-row">
              <strong>Ask Me Anything</strong>
              <small>Anonymous · no login needed</small>
            </div>
            <div className="ama-launch-fake-input">
              <span className="ama-launch-typed-question">What's your favorite movie?</span>
              <span className="ama-launch-submit-example">Submit</span>
            </div>
            <div className="ama-launch-url">{creatorSlug ? `shoutout.fans/${creatorSlug}` : 'yourname.fans'}</div>
          </div>
        </div>

        <div className="ama-launch-scene ama-launch-scene-creator">
          <div className="ama-launch-scene-label"><span>2</span> You tap Answer</div>
          <div className="ama-launch-inbox-card">
            <div className="ama-launch-inbox-meta">
              <span>Anonymous</span><b>NEW</b>
            </div>
            <div className="ama-launch-question-badge">
              <small>Ask Me Anything</small>
              <strong>What's your favorite movie?</strong>
            </div>
            <div className="ama-launch-answer-button">
              <span className="ama-launch-answer-pulse" />
              Answer
            </div>
          </div>
        </div>

        <div className="ama-launch-scene ama-launch-scene-story">
          <div className="ama-launch-scene-label"><span>3</span> Share it to Instagram Stories</div>
          <div className="ama-launch-story-frame">
            <div className="ama-launch-story-topline">
              <InstagramGlyph className="ama-launch-instagram-icon" />
              <strong>Your Story</strong>
              <span>•••</span>
            </div>
            <div className="ama-launch-story-badge">
              <small>Ask Me Anything</small>
              <strong>What's your favorite movie?</strong>
              <p>Ask Me Anything · Click ShoutOut link in my bio</p>
            </div>
            <div className="ama-launch-story-stats">
              <span>✓ Story posted</span>
              <span>♡</span>
              <span>↗</span>
            </div>
          </div>
        </div>
      </div>

      <div className="ama-launch-mobile-demo">
        <div className="ama-launch-mobile-step ama-launch-mobile-step-fan">
          <small><b>1</b> A fan asks anonymously</small>
          <div className="ama-launch-mobile-fan-card">
            <span className="ama-launch-mobile-question-text">What's your favorite movie?</span>
            <i>↑</i>
          </div>
        </div>
        <div className="ama-launch-mobile-step ama-launch-mobile-step-answer">
          <small><b>2</b> You tap Answer</small>
          <div className="ama-launch-mobile-answer-card">
            <span>What's your favorite movie?</span>
            <i>Answer</i>
          </div>
        </div>
        <div className="ama-launch-mobile-step ama-launch-mobile-step-story">
          <small><b>3</b> Post it to your Story</small>
          <div className="ama-launch-mobile-story-card">
            <InstagramGlyph className="ama-launch-mobile-instagram" />
            <span>What's your favorite movie?</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AmaFeatureDemo;
